import * as z from 'zod';
import { SCRIPT_SCHEMA } from '../scripting';
import { CloseComponentAction, ReloadComponentDataAction, SetDataAction, CacheAction, ClearCacheAction } from './component';
import { CRUDAction } from './crud';
import { EmitAction } from './emit';
import { FormAction } from './form';
import { LogoutAction } from './logout';
import { CloseModalAction, ShowModalAction } from './modal';
import { NavigateAction } from './navigate';
import { NotificationAction, ToastMessageAction } from './notifications';
import { PowerAction } from './power';
import { RegisterAction } from './register';
import { RequestAction } from './request';
import { ResourceAction } from './resource';
import { RestAction } from './rest';
import { ScriptAction } from './script';
import { ReloadSlickgridAction } from './slickgrid';
export const CONFIRM_SPEC_SCHEMA = z.object({
    header: z.string().optional(),
    message: z.string(),
    btnOk: z.string().optional(),
    btnCancel: z.string().optional(),
    severity: z.string().optional()
});
const ACTION = z.object({
    state: z.string().optional(),
    id: z.string().optional(),
    when: SCRIPT_SCHEMA().optional(),
    confirm: CONFIRM_SPEC_SCHEMA.optional(),
    events: z.array(z.lazy(() => EVENT_HANDLER_SPEC_SCHEMA_FACTORY())).optional()
});
function actionSchema(cls) {
    return ACTION.extend({
        name: z.literal(cls.name),
        args: cls.schema
    });
}
export const ACTION_SPEC_SCHEMA = z.lazy(() => z.discriminatedUnion('name', [
    actionSchema(CacheAction.manifest),
    actionSchema(ClearCacheAction.manifest),
    actionSchema(CloseComponentAction.manifest),
    actionSchema(CloseModalAction.manifest),
    actionSchema(CRUDAction.manifest),
    actionSchema(EmitAction.manifest),
    actionSchema(FormAction.manifest),
    actionSchema(LogoutAction.manifest),
    actionSchema(NavigateAction.manifest),
    actionSchema(NotificationAction.manifest),
    actionSchema(PowerAction.manifest),
    actionSchema(RegisterAction.manifest),
    actionSchema(ReloadComponentDataAction.manifest),
    actionSchema(ReloadSlickgridAction.manifest),
    actionSchema(RequestAction.manifest),
    actionSchema(ResourceAction.manifest),
    actionSchema(RestAction.manifest),
    actionSchema(ScriptAction.manifest),
    actionSchema(ShowModalAction.manifest),
    actionSchema(SetDataAction.manifest),
    actionSchema(ToastMessageAction.manifest)
]));
export const EVENT_HANDLER_SPEC_SCHEMA_FACTORY = () => z.object({
    name: z.string(),
    action: ACTION_SPEC_SCHEMA,
    disabled: z.boolean().optional(),
    when: SCRIPT_SCHEMA().optional(),
    parameters: z.array(z.string()).optional()
});
export const EVENT_HANDLER_SPEC_SCHEMA = EVENT_HANDLER_SPEC_SCHEMA_FACTORY();
export const SUBSCRIPTION_SPEC_SCHEMA = z.object({
    event: z.string(),
    action: ACTION_SPEC_SCHEMA,
    disabled: z.boolean().optional(),
    when: SCRIPT_SCHEMA().optional(),
    parameters: z.array(z.string()).optional()
});
//# sourceMappingURL=schemas.js.map